import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { spApi, setSPToken, SP_TOKEN_KEY, spFormatError } from "./api";

const SPAuthContext = createContext(null);

export function SPAuthProvider({ children }) {
  const [actor, setActor] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem(SP_TOKEN_KEY);
    if (!t) {
      setActor(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await spApi.get("/auth/me");
      setActor(data.actor);
    } catch {
      setSPToken(null);
      setActor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await spApi.post("/auth/login", { email, password });
    setSPToken(data.token);
    setActor(data.actor);
    return data.actor;
  };

  const logout = async () => {
    try { await spApi.post("/auth/logout"); } catch {/*noop*/}
    setSPToken(null);
    setActor(null);
  };

  return (
    <SPAuthContext.Provider value={{ actor, loading, login, logout, refresh, formatError: spFormatError }}>
      {children}
    </SPAuthContext.Provider>
  );
}

export const useSPAuth = () => useContext(SPAuthContext);
